var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header",on:{"click":_vm.collapse}},[_c('div',{class:{'arrow-down arrow-down--has-hover': _vm.isCollapsed, 'arrow-up arrow-up--has-hover': !_vm.isCollapsed}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }